import helpIcon from '@jetbrains/icons/help-20px.svg'
import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import {TrayIcon} from '@jetbrains/ring-ui/components/header/header'
import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import PopupMenu from '@jetbrains/ring-ui/components/popup-menu/popup-menu'
import {memo} from 'react'
import * as React from 'react'

import {useHelpDropdownContent} from '../../../common/HelpDropdown/HelpDropdown.consts'

const PopupDirections = [Directions.BOTTOM_LEFT]

function HeaderTrayHelp() {
  const popupMenuItems = useHelpDropdownContent()

  return (
    <Dropdown
      data-test={'help-dropdown'}
      anchor={<TrayIcon title="Help" icon={helpIcon} />}
      hoverMode
    >
      <PopupMenu directions={PopupDirections} data={popupMenuItems} closeOnSelect />
    </Dropdown>
  )
}

export default memo(HeaderTrayHelp)
